<template src="./customizeSurveyModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import surveysEndpoints from '../surveys.endpoints';

export default {
    name: 'customize-survey-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            dto: {
                LogoBase64: ''
            },
            dropdownFields: {
                text: 'Text',
                value: 'Value',
            },
            customization: null,
        }
    },
    computed: {
    },
    methods: {
        btnSaveOnClick() {
            surveysEndpoints.updateCustomization(this.dto)
                .then(() => {
                    this.successClose(this.dto);
                });
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        getCustomizationByID() {            
            surveysEndpoints.getCustomizationByID(this.dto.IntermediaryID)
                .then((response) => {
                    this.dto = response;
                })
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function () {
                    return resolve(reader.result);
                }
            })
        },
        saveLogoFile(e) {
            let logoFile = e.target.files[0];
            console.log(logoFile)

            this.getBase64(logoFile)
                .then((response) => {
                    this.dto.LogoBase64 = response;
                })
        },
        uploadFile() {
            console.log(logoFilePicker)
            logoFilePicker.click();
        },
        removeFile() {
            this.dto.LogoBase64 = '';
        }
    },
    created() {
        if (this.$store.state.intermediaryOptions.length === 1) {
            this.dto.IntermediaryID = this.$store.state.intermediaryOptions[0].Value;

            this.getCustomizationByID();
        }
    },
}
</script>